import React, { Component } from 'react';
import '../myutils';
import {
    translate,
} from 'react-admin'; 
import BookIcon from '@material-ui/icons/Book'; 
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialPad from '../Softphone/dialpad';
import CommunicationPhone from '@material-ui/icons/Phone';
import Badge from '@material-ui/core/Badge';
import { push as pushAction } from 'react-router-redux';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import IncomingCalls from '../res/IncomingCalls';
export const TemplateIcon = BookIcon;

class QuickCallButton extends Component {

    state = {
        open: false,
      };
      constructor(props) {
        super(props);
        this.state = {
        }
    
      }
          
      handleClickOpen = () => {
        this.setState({ open: true });
      };
    
      handleClose = () => {
        this.setState({ open: false });
      };

      render() {
        const { translate } = this.props;
        return (
          <div style={{float:"right", textAlign:'center'}}>
              <Button
                style={{backgroundColor:'#bdbdbd'}}
                variant="fab"
                mini
                color='primary'
                label={translate(`resources.Softphone.quick_call`)}
                onClick={this.handleClickOpen}
                >
                    <Badge badgeContent={<IncomingCalls/>} color="default">
                        <CommunicationPhone style={{color:"white"}}/>
                    </Badge>
                </Button>

            <Dialog
              open={this.state.open}
              onClose={this.handleClose}
              aria-labelledby="form-dialog-title"
            >
                <IconButton color="default" onClick={(e)=>this.handleClose(e)} aria-label="Close" style={{ float: 'right' }}>
                  <CloseIcon />
                </IconButton>
                <DialPad/>
            </Dialog>
          </div>
        );
    }
}

export default connect(null, {
    push: pushAction,
})(translate(QuickCallButton));